import React from 'react';
import '../../styles/Modal.css';

const Modal = ({ title, children, onClose }) => {
  return (
    <div className="modal-backdrop">
      <div className="modal-window">
        {title && <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-button" onClick={onClose}>X</button>
        </div>}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
